// get ecustomer list for admin workforce
export const GET_CUSTOMER_Details = "GET_CUSTOMER_Details";
export const GET_CUSTOMER_Details_SUCCESS = "GET_CUSTOMER_Details_success";
export const GET_CUSTOMER_Details_FAILURE = "GET_CUSTOMER_Details_failure";
